import React from 'react'
import { Form } from '@ant-design/compatible'
import '@ant-design/compatible/assets/index.css'
import 'antd4/lib/grid/style/index.css'
import { Modal, Input, InputNumber } from 'hljd'
import { inject, observer } from 'mobx-react'
import { toJS } from 'mobx'

const validateRate = (rule, value, callback) => {
  const _rule = Number(value)
  if (_rule === 0 || _rule > 0) {
    callback()
  } else {
    callback()
  }
}
@observer
@inject('store')
class AddGiftModalComponent extends React.Component {
  render() {
    const {
      fields: { modalStatus },
      form: { getFieldDecorator },
      store: { liveLotteryStore },
      handleConfirm
    } = this.props
    const { liveLotteryModalVisible, emptyLiveLottery } = liveLotteryStore
    const formItemLayout = {
      labelCol: { span: 4 },
      wrapperCol: { span: 19, offset: 1 },
      colon: false
    }
    return (
      <Modal
        title={modalStatus ? '编辑抽奖' : '添加抽奖'}
        visible={liveLotteryModalVisible}
        onOk={handleConfirm}
        onCancel={emptyLiveLottery}
      >
        <Form layout="horizontal">
          <Form.Item
            label="礼品"
            {...formItemLayout}
            extra="礼品字数最多允许输入15位！"
          >
            {getFieldDecorator('giftName', {
              rules: [
                { required: true, message: '请输入礼品', whitespace: true }
              ]
            })(
              <Input
                maxLength={15}
                placeholder="请输入抽奖内容，例如“迪奥999口红"
                disabled={modalStatus == 'limit' || modalStatus == 'view'}
              />
            )}
          </Form.Item>
          <Form.Item
            label="中奖概率"
            {...formItemLayout}
            extra="概率越高，用户抽中奖品可能性越大"
          >
            {getFieldDecorator('rate', {
              rules: [
                { required: true, message: '请输入中奖概率' },
                { validator: validateRate }
              ]
            })(
              <InputNumber
                disabled={modalStatus == 'view'}
                precision={1}
                min={0}
                max={100}
                step={0.1}
              />
            )}
            <span
              style={{
                marginLeft: '10px',
                fontSize: '14px',
                color: '#333'
              }}
            >
              %
            </span>
          </Form.Item>
          <Form.Item label="奖品数量" {...formItemLayout}>
            {getFieldDecorator('number', {
              rules: [{ required: true, message: '请输入奖品数量' }]
            })(
              <InputNumber
                precision={0}
                min={1}
                step={1}
                disabled={modalStatus == 'limit' || modalStatus == 'view'}
              />
            )}
          </Form.Item>
          <Form.Item
            label="观看时长"
            {...formItemLayout}
            extra="表示用户观看满多长时间后出现本次抽奖"
          >
            {getFieldDecorator('watchTime', {
              rules: [{ required: true, message: '请输入观看时长' }]
            })(
              <InputNumber
                precision={0}
                min={1}
                step={1}
                disabled={modalStatus == 'view'}
              />
            )}
            <span
              style={{
                marginLeft: '10px',
                fontSize: '14px',
                color: '#333'
              }}
            >
              秒
            </span>
          </Form.Item>
        </Form>
      </Modal>
    )
  }
}
export default Form.create({
  name: 'addGiftModal',
  mapPropsToFields(props) {
    //把父组件的属性映射到表单项上
    const fields = props.fields
    const keys = Object.keys(fields)
    const res = {}
    for (let key of keys) {
      res[key] = Form.createFormField({ value: toJS(fields[key]) })
    }
    return res
  },
  onValuesChange(props, changedValues) {
    //任意value发生改变
    props.onChange(changedValues)
  }
})(AddGiftModalComponent)
